import { PlaybookStatus } from '@driftt/api-types'
import { IconMenuButton } from '@driftt/dds'
import React, { useEffect, useState } from 'react'

import { BlockTableRow } from 'api/blocks'
import { checkCanClonePlaybookAsBlock } from 'api/playbooks'
import { isEmptyOrNil } from 'utils/index'

type ManagedPlaybookStatus = PlaybookStatus.ARCHIVED | PlaybookStatus.ENABLED

interface CloneExclusions {
  [key: string]: boolean | string
}

const BlocksActionCell = ({
  blockRowData,
  onUnarchive,
  onDelete,
  onClone,
  onArchive,
  blockStatus,
}: {
  blockRowData: BlockTableRow
  onUnarchive: () => void
  onDelete: () => void
  onClone: () => void
  onArchive: () => void
  blockStatus: ManagedPlaybookStatus
}) => {
  const [cloneBlockExclusions, setCloneBlockExclusions] =
    useState<CloneExclusions>()
  const { playbookBlockData } = blockRowData

  useEffect(() => {
    const getAndFormatCloneErrors = async (pbIds: number[]) => {
      try {
        const blockCloneExclusionsArray = await Promise.all(
          pbIds.map(async (pbId) => {
            const { data: blockCloneExclusions } =
              await checkCanClonePlaybookAsBlock(pbId)
            return blockCloneExclusions as CloneExclusions
          })
        )
        return blockCloneExclusionsArray.reduce(
          (accumulatedExclusions, currentExclusions) => {
            Object.keys(currentExclusions).forEach((key) => {
              if (accumulatedExclusions[key]) {
                accumulatedExclusions[key] =
                  accumulatedExclusions[key] || currentExclusions[key]
              } else {
                accumulatedExclusions[key] = currentExclusions[key]
              }
            })
            return accumulatedExclusions
          },
          {}
        )
      } catch (e) {
        console.warn(e)
      }
    }

    if (
      isEmptyOrNil(cloneBlockExclusions) &&
      !isEmptyOrNil(playbookBlockData)
    ) {
      const playbookIds = playbookBlockData.map((data) => data.playbookId)
      getAndFormatCloneErrors(playbookIds).then((data) => {
        setCloneBlockExclusions(data || {})
      })
    }
  }, [cloneBlockExclusions, playbookBlockData])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const hasBlockExclusion = !!cloneBlockExclusions?.blockExclusion

  const MENU_ACTIONS_BY_STATUS = Object.freeze({
    [PlaybookStatus.ARCHIVED]: [
      {
        name: 'Restore',
        action: onUnarchive,
      },
      {
        name: 'Delete',
        action: onDelete,
        disabled: !isEmptyOrNil(playbookBlockData),
      },
    ],
    [PlaybookStatus.ENABLED]: [
      {
        name: 'Clone',
        // name: hasBlockExclusion
        //   ? 'Cloning restricted: Reusable block in use'
        //   : 'Clone',
        action: onClone,
        // disabled: hasBlockExclusion,
      },
      {
        name: 'Archive',
        action: onArchive,
        disabled: !isEmptyOrNil(playbookBlockData),
      },
    ],
  })

  return (
    <IconMenuButton
      iconVariant="spillover"
      title=""
      options={MENU_ACTIONS_BY_STATUS[blockStatus]}
    />
  )
}

export default BlocksActionCell
